module.exports = __webpack_public_path__ + "df5efe00a0cd021464a02de2f52546df.svg";